import isEmpty from 'lodash/isEmpty'
import React from 'react'
import { injectIntl, MessageDescriptor, WrappedComponentProps } from 'react-intl'
import { WrappedFieldInputProps, WrappedFieldMetaProps } from 'redux-form'
import styled, { css } from 'styled-components'
import { color } from 'utils'

import { active, color as inputColor, input, label } from './Input/theme'
import SingleDropdown from './Legacy/SingleDropdown'
import { InputSizeType } from './types'

export type SelectOptionValueType = string | number

export type SelectOptionItemType = {
  text: string | MessageDescriptor
  value: SelectOptionValueType
}

export type SelectOptionItemsType = Array<SelectOptionItemType>

type PropsType = WrappedComponentProps & {
  historyDownload?: boolean
  input?: Partial<WrappedFieldInputProps>
  items: SelectOptionItemsType
  meta?: Partial<WrappedFieldMetaProps>
  showError?: boolean
  variant: string
}

const StyledSelectOption = styled(SingleDropdown)<PropsType>`
  height: auto;

  label {
    ${label};
  }

  select {
    ${input};

    &:active:not(:disabled),
    &:focus:not(:disabled) {
      ${active};
    }

    &:active:not(:disabled):not([readonly]),
    &:focus:not(:disabled):not([readonly]) {
      ${active};
    }

    ${(props: PropsType) =>
      props.variant === 'sidebar' ? 'font-size: 0.75rem; padding: 0 2rem 0 1rem;' : ''}
  }

  option {
    color: ${color('dark900')};
  }

  &::after {
    border-top-color: ${inputColor(6)};
    ${(props: PropsType) =>
      props.variant === 'sidebar'
        ? css`
            bottom: 0.5rem;
            border-left-width: 0.25rem;
            border-right-width: 0.25rem;
            border-top-width: 0.25rem;
            right: 1.5rem;
          `
        : ''}
    ${({ historyDownload }: PropsType) => (historyDownload ? 'bottom: 0.825rem;' : '')}
  }
`

const defaultProps = {
  meta: {},
  showError: true,
  size: 'md' as InputSizeType,
  variant: 'normal'
}

// https://react-typescript-cheatsheet.netlify.app/docs/basic/getting-started/default_props/
const SelectOption = ({
  input,
  intl,
  items,
  meta,
  showError,
  ...rest
}: PropsType & typeof defaultProps) => {
  const { error, touched } = meta || {}
  const errorMessage: string = showError === true && touched ? error || '' : ''
  const data = items.map((item) => ({
    text: typeof item.text !== 'string' ? intl.formatMessage(item.text) : item.text,
    value: item.value
  }))

  return (
    <StyledSelectOption
      {...rest}
      {...input}
      error={isEmpty(errorMessage) ? undefined : errorMessage}
      intl={intl}
      items={data}
    />
  )
}

export default injectIntl(SelectOption)
